module.exports = __webpack_public_path__ + "media/images/icon__dropdown--arrow@2x-0d9fb946ace1819121f75ecf2416cd76.png";